/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { defaultItemDisplayStringFunction } from "abreact/incubator/ui/form/AbInputUtils";
import { AbEnriched } from "abreact/utils/enrichment/AbEnriched";
export class AbItemUtils {
  /**
   * Returns the default display name for the specified item.
   */
  static defaultItemDisplayName(item, itemEnrichment) {
    const enrichment = itemEnrichment ?? AbEnriched.getEnrichment(item);
    if (enrichment?.displayName) {
      return enrichment.displayName;
    }
    return defaultItemDisplayStringFunction(AbEnriched.getItem(item));
  }
}
//# sourceMappingURL=AbItemUtils.js.map
